import React, { useCallback, useEffect, useState } from 'react'
import Skeleton from '../skeleton'
import * as Icon from 'ubs-icons';
import UInput from "ubs-framework/v2/UInput";
import URadio from 'ubs-framework/v2/URadio';
import Select from 'react-select';
import UCustomScrollBar from '../UCustomScrollBar';
import CheckBox from '../UCheckBox';
import UNoDataFound from '../UErrorPages/UNoDataFound';
import { errorFocus, getKeyName } from '../common/function';
import UDatePicker from "../UDatePicker";
import ReactStars from "../UStars";
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css'
import { COLOR } from "../common/constant";
import UFileInfo from "../UFileInfo";
import QuestionSkeleton from "./question-skeleton";
import { useSelector } from 'react-redux';
import UTags from "../UTags";
import {showMoreText} from "../ShowMoreText";

let i = 0;

function ViewForm(props) {
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    /** section wise submit answer */
    const [sectionIndex, setSectionIndex] = useState(0)

    const downloadFiles = (file) => {
        let iframe = document.createElement("iframe");
        iframe.style.visibility = "collapse";
        document.body.append(iframe);
        const url = props?._S3_BASE_URL + file.url;
        // eslint-disable-next-line
        iframe.contentDocument.write(`<form action="${url.replace(/\"/g, '"')}" method="GET"/>`);
        iframe.contentDocument.forms[0].submit();

        setTimeout(() => iframe.remove(), 2000);
    };

    /** section wise submit answer */
    useEffect(() => {
        /**
         * initially i set as 0, while user submit survey and try to submit again then i value reset by 0
         * */
        i = 0
    }, []);

    const section = {
        clearForm: () => {
            /** clear form */
            i = 0
            setSectionIndex(0)
            localStorage.removeItem('survey-answer')
            window.location.reload(false);
        },
        test: e => {
            /**
             * testing purpose
             * */
            props?.validator?.current?.hideMessages();
            props?.handle?.clear('answer-3')
        },
        goBack: (index) => {
            i = index - 1
            setSectionIndex(index - 1)
        },
        next: (e) => {
            let validated = true
            i++
            let questionList = JSON.parse(localStorage.getItem('survey-answer')) || []
            let sectionList = JSON.parse(JSON.stringify(props.sectionList)) || []

            let sectionWiseQuestion = questionList.filter(_ => _.sectionId === (sectionIndex + 1))

            sectionWiseQuestion.map((qData, qIndex) => {
                /**
                 * logic for check question validation
                 * */
                if (qData?.isMandatory && (qData?.type === 3 ? !qData?.hasOwnProperty('answer') : (props?.validator.current.errorMessages[`answer-${qData?.queIndex}`] !== null && props?.validator.current.errorMessages[`answer-${qData?.queIndex}`] !== undefined))) {
                    validated = false
                }
            })
            if (validated) {
                let sectionQuestionList = questionList.filter(_ => _?.sectionId === i) // get active section's questions
                if (sectionList[i - 1]?.section?.sectionType === 1 || sectionList[i - 1]?.sectionType === 1) {
                    /**
                     * continue with next section
                     * add question type single choice and dropdown
                     * */
                    let sectionQuestion = sectionQuestionList?.find(_ => _?.isSection) // get Go to section based on answer details
                    if ([4, 6].includes(sectionQuestion?.type)) {
                        /**
                         * for single choice and dropdown questions
                         * */
                        if (sectionQuestion?.answer === undefined) {
                            /**
                             * goto direct last section if user not enter data
                             * */
                            setSectionIndex(i + 1)
                        } else {
                            let sectionIndex = sectionQuestion?.options.find(_ => _?.value === sectionQuestion?.answer[0])
                            if (sectionIndex?.section?.next || sectionIndex?.next) {
                                setSectionIndex(sectionIndex?.section?.next - 1 || sectionIndex?.next - 1) /** sectionIndex?.section?.next - 1 due to we have start section index from 0 */
                            } else {
                                /**
                                 * direct submit if user set submit form
                                 * */
                                i = props?.sectionList?.length + 1
                                setSectionIndex(props?.sectionList?.length + 1)
                            }
                        }

                    } else {
                        /**
                         * for other questions
                         * */
                        if (sectionList[i - 1]?.section?.next) {
                            setSectionIndex((sectionList[i]?.section?.next - 1 || sectionList[i]?.next - 1) || i)
                            // i = sectionList[i]?.section?.next - 1
                        } else {
                            setSectionIndex(i)
                        }
                    }


                } else if (sectionList[i - 1]?.section?.sectionType === 2 || sectionList[i - 1]?.sectionType === 2) {
                    /**
                     * continue with particular section
                     * */

                    setSectionIndex((sectionList[i - 1]?.section?.next - 1 || sectionList[i - 1]?.next - 1) || i)

                } else if (sectionList[i - 1]?.section?.sectionType === 3 || sectionList[i - 1]?.sectionType === 3) {
                    /**
                     * submit survey
                     * */
                    i = props?.sectionList?.length
                    setSectionIndex(props?.sectionList?.length)
                }
            } else {
                i--
                props?.validator?.current?.showMessages();
                errorFocus();
            }
        },
        clear: (name) => {
            props.validator.current.hideMessageFor(name)
            props.validator.current.errorMessages[name] = null
            delete props.validator.current.errorMessages[name]
            props.validator.current.fields[name] = true
        },
        submitData: e => {
            let sectionList = JSON.parse(JSON.stringify(props.sectionList)) || []

            let sectionWiseQuestion = props?.questionList.filter(_ => _.sectionId === (sectionIndex + 1))
            let flag = true
            sectionWiseQuestion.map((qData, qIndex) => {
                /**
                 * logic for check question validation
                 * */

                if (qData?.isMandatory && (qData?.type === 3 ? !qData?.hasOwnProperty('answer') : (props?.validator.current.errorMessages[`answer-${qData?.queIndex}`] !== null && props?.validator.current.errorMessages[`answer-${qData?.queIndex}`] !== undefined))) {
                    flag = false
                }
            })
            if (sectionList?.length > 2 || flag) {
                props?.validator.current.purgeFields()
                props?.validator?.current?.hideMessages();
                props?.handle?.clear(`answer-${i}`)
                props?.handle?.clear(`answer-${i - 1}`)
                props.handle?.submit(e);
            } else {
                props?.validator?.current?.showMessages();
                errorFocus();
            }
        }
    }

    return (
        <React.Fragment>
            <UCustomScrollBar>
                <div className={`u_template-que-view u_p-15 u_pb-15 ${props?.className ? props?.className : ''}`}>
                    {props?.questionDetail?.companyDetail?.logoURL && <div className="u_company-logo">
                        <img src={_S3_BASE_URL + props?.questionDetail?.companyDetail?.logoURL} alt={props?.questionDetail?.companyDetail?.company}
                            title={props?.questionDetail?.companyDetail?.company} />
                    </div>}

                    {props.questionDetail?.name && <div className="u_que-header u_mb-15">
                        {props.loader ? <Skeleton width='100%' height='18px' className="u_mb-5" /> : <h4>{props.questionDetail?.name}</h4>}
                        {props.loader ? <Skeleton width='100%' height='32px' /> : <p>{props.questionDetail?.description}</p>}
                    </div>}

                    {props.loader && <QuestionSkeleton />}

                    {props?.isSurvey ? !props.loader && props.sectionList?.map((section, index) => {
                        return (
                            <div className={`u_section ${index === sectionIndex && 'u_active'}`} id={`section-${index + 1}`} key={index}>
                                <div className="u_survey-section u_mb-15">
                                    <p className="u_survey-section-number">{index + 1}</p>
                                    <div className="u_survey-section-content u_flex-1-0">
                                        <h5 className="u_que-title u_ws-pre-line">{section?.name}</h5>
                                        <p className="u_que-description u_mt-10 u_small-font u_ws-pre-line">{section?.description}</p>
                                    </div>
                                </div>
                                {props.questionList?.map((que, i) => {
                                    return (
                                        (index + 1) === que?.sectionId && ![16].includes(que.type) && <div className="u_que-list" key={i}>
                                            <div className="u_que-list-inner">
                                                <div className="u_mb-15">
                                                    <h5 className="u_que-title u_ws-pre-line">{i + 1}. {que?.title}{que?.isMandatory && <span className="u_error">*</span>}</h5>
                                                    <p className="u_que-description u_mb-10 u_ws-pre-line">{que?.hint}</p>
                                                </div>
                                                <div className="u_que-list-content">
                                                    <QuestionType
                                                        question={que}
                                                        validator={props.validator}
                                                        handle={props.handle}
                                                        fileLoader={props.fileLoader}
                                                        fileArray={props.fileArray}
                                                        fileResponse={props.fileResponse}
                                                        _S3_BASE_URL={props._S3_BASE_URL}
                                                        index={i}
                                                    />
                                                    {que?.isComment && <CommentBox question={que} index={i} handle={props.handle} />}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    }) : !props.loader && props?.questionList?.map((que, i) => {
                        return (
                            ![16].includes(que.type) && <div className="u_que-list" key={i}>
                                <div className="u_que-list-inner">
                                    <div className="u_mb-15">
                                        <h5 className="u_que-title u_ws-pre-line">{i + 1}. {que?.title}{que?.isMandatory && <span className="u_error">*</span>}</h5>
                                        <p className="u_que-description u_mb-10 u_ws-pre-line">{que?.hint}</p>
                                    </div>
                                    <div className="u_que-list-content">
                                        <QuestionType
                                            question={que}
                                            validator={props.validator}
                                            handle={props.handle}
                                            fileLoader={props.fileLoader}
                                            fileArray={props.fileArray}
                                            fileResponse={props.fileResponse}
                                            _S3_BASE_URL={props._S3_BASE_URL}
                                            index={i}
                                        />

                                        {que?.isComment && <CommentBox question={que} index={i} handle={props.handle} />}

                                        {/*Display status and explanation for question bank */}
                                        {que?.answer !== null && que?.answerStatus && (
                                            <div className="u_mt-15">
                                                <div className="u_flex u_align-center u_justify-end u_content-end u_mb-10">
                                                    {que?.answerStatus === 1 ? (
                                                        <UTags title={"Correct"} color={COLOR.u_green} className="u_ib"/>
                                                    ) : que?.answerStatus === 2 ? (
                                                        <UTags title={"Partially Correct"} color={COLOR.u_orange} className="u_ib"/>
                                                    ) : que?.answerStatus === 3 ? (
                                                        <UTags title={"Incorrect"} color={COLOR.u_red} className="u_ib"/>
                                                    ) : null}
                                                </div>

                                                {que?.answer !== null && que?.answerExplanation && (
                                                    <div className={`u_mt-10 u_p-12 u_flex u_gap-10 ${que?.answerStatus === 1 ? "u_screening-questions-view green u_bg-green-1" : que?.answerStatus === 2 ? "u_screening-questions-view orange u_bg-orange-1" : "u_screening-questions-view red u_bg-red-1"}`}>
                                                        <div>
                                                            <p className={`u_small-font u_text-bold u_mb-5 ${que?.answerStatus === 1 ? "u_color-green" : que?.answerStatus === 2 ? "u_color-orange" : "u_color-red" }`}>
                                                                Explanation:
                                                            </p>
                                                            <p className="u_small-font u_color-title">
                                                                {que?.answerExplanation || '-'}
                                                            </p>
                                                     </div>
                                                    </div>)}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                    {/** type 16. heading & description is visible only in footer */}
                    {!props.loader && props?.questionList?.map((que, i) => {
                        return (
                            [16].includes(que.type) && <div className="u_template-que-view-footer u_mb-30 u_pt-30 u_mt-30" key={i}>
                                <h5 className="u_mb-15 u_ws-pre-line">{que?.title}</h5>
                                <p className="u_ws-pre-line">{que?.content}</p>
                            </div>
                        )
                    })}

                    {/** Click to submit survey */}
                    {sectionIndex >= props?.sectionList?.length && <div className="u_my-15">
                        <p className="u_small-font u_color-title">Click submit to finish.</p>
                    </div>}

                    {/** Evaluation Form scorecard */}
                    {props?.evaluation && props?.evaluationType === 1 && <div className="u_que-list">
                        <div className="u_que-list-inner">
                            <div className="u_evaluation-score">
                                <label className="u_label">{props?.evaluationScore?.title}{props?.evaluationScore?.isMandatory && <span className="u_astric ">*</span>}</label>
                                {props?.evaluationScore?.isShowNote && <UInput label="" textarea asterisk={props?.question?.isMandatory}
                                    hasError={props?.evaluationScore?.isMandatory ? props?.validator?.current?.message("evaluationNote", props?.EVNote, "required|max:500,string") : false}>
                                    <textarea
                                        className={`u_textarea u_textarea-six-rows u_mt-15`}
                                        placeholder="Add Note"
                                        name="description"
                                        value={props?.EVNote}
                                        autoComplete="off"
                                        maxLength={500}
                                        onChange={(e) => props?.handle.changeEVNote(e)}
                                    />
                                </UInput>}
                                <div className="u_mt-10 u_flex u_align-center u_evaluation-score-btn">
                                    <span className={`u_evaluation-btn ${props?.EVScore === 1 ? 'u_active-red' : ''}`} onClick={() => props?.handle.changeEVScore(1)}>
                                        <Icon.DisLike fill={props?.EVScore === 1 ? COLOR.u_red : COLOR.u_icon_bg} size={16} className="u_mr-10" />No
                                    </span>
                                    <span className={`u_evaluation-btn ${props?.EVScore === 2 ? 'u_active-orange' : ''}`} onClick={() => props?.handle.changeEVScore(2)}>
                                        <Icon.NotSure fill={props?.EVScore === 2 ? COLOR.u_orange : COLOR.u_icon_bg} size={16} className="u_mr-10" />Not Sure
                                    </span>
                                    <span className={`u_evaluation-btn ${props?.EVScore === 3 ? 'u_active-green' : ''}`} onClick={() => props?.handle.changeEVScore(3)}>
                                        <Icon.Like fill={props?.EVScore === 3 ? COLOR.u_green : COLOR.u_icon_bg} size={16} className="u_mr-10" />Yes
                                    </span>
                                    <span className={`u_evaluation-btn ${props?.EVScore === 4 ? 'u_active-green' : ''}`} onClick={() => props?.handle.changeEVScore(4)}>
                                        <Icon.DoubleThumbsUp fill={props?.EVScore === 4 ? COLOR.u_green : COLOR.u_icon_bg} size={16} className="u_mr-10" />Strong Yes
                                    </span>
                                </div>
                            </div>
                            {(props?.EVScore === '' && props?.evaluationScore?.isMandatory) && <p className="u_error">Please evaluate this candidate</p>}
                        </div>
                    </div>}

                    {props?.isSurvey ? <div className="u_submit-btn">
                        {/** (sectionIndex + 1) for single section fill answers */}
                        <div className="u_flex-align u_flex-1-0">
                            {sectionIndex > 0 && <button type="submit" className={`u_btn u_btn__smallBtn u_btn__white u_mr-10 ${props?.fileLoader && 'u_btn-disabled'}`}
                                onClick={(e) => section.goBack(sectionIndex)}>{'Back'}</button>}

                            {(sectionIndex + 1 < props?.sectionList?.length) &&
                                <button type="submit" className={`u_btn u_btn__smallBtn u_btn__blue u_mr-10 ${props?.fileLoader && 'u_btn-disabled'}`}
                                    onClick={(e) => section?.next(e)}>Next</button>}

                            {(sectionIndex + 1 >= props?.sectionList?.length) &&
                                <button type="submit" className={`u_btn u_btn__smallBtn u_btn__blue u_mr-10 ${props?.fileLoader && 'u_btn-disabled'}`}
                                    onClick={(e) => section.submitData(e)}>{props?.submitBtn || 'Submit'}</button>}
                        </div>
                        <div>
                            <p className="u_small-font u_cp u_color-blue u_inline-flex" onClick={() => section.clearForm()}>Clear Form</p>
                        </div>
                    </div> : (props?.uac || props?.isQuesionary) && <div className={props?.candidateInfo?.status === 1 ? 'u_flex u_content-between' : props?.isQuesionary ? 'u_question_view' : 'u_submit-btn'}>
                        {!props.loader && props.questionDetail?.status !== 4 && !props?.noButton && <div>
                            <button type="submit" className={`u_btn u_btn__smallBtn u_btn__blue ${props?.fileLoader && 'u_btn-disabled'}`} style={{ width: '120px' }}
                                onClick={(e) => props.handle?.submit(e)}>{props?.submitBtn || 'Submit'}</button>
                        </div>}
                        {props?.isQuesionary && <div className='u_flex-align'>
                            <div className='u_px-10'>
                                <p className="u_small-font u_cp u_color-blue u_inline-flex" onClick={(e) => props?.clear(e)}>Clear Form</p>
                            </div>
                        </div>}
                        {props?.candidateInfo?.status === 1 && <div className='u_flex-align '>
                            <div className='u_px-4'>
                                <p className="u_small-font u_cp u_color-red u_inline-flex" onClick={(e) => props?.cancel(e)}>Cancel Request</p>
                            </div>
                            <div className='u_px-4'>
                                <p className="u_small-font u_cp u_color-blue u_inline-flex" onClick={(e) => props?.clear(e)}>Clear Form</p>
                            </div>
                        </div>}
                    </div>}

                    {props?.isSurvey || props?.candidateInfo?.status === 1 && <div className="u_powerby u_flex u_align-center u_flex-wrap u_content-center u_mt-15">
                        <span className="u_flex u_align-center u_content-center u_w-full u_text-center"><p className="u_mr-3"> Powered by</p> <Icon.Superworks size={16} /><strong>Super
                            {props?.product ? props?.product : 'Survey'}</strong> </span>
                        {!props?.product && <p className="u_que-placeholder">Create unlimited online survey for free</p>}
                    </div>}

                    {!props.loader && props?.questionList?.length === 0 && <UNoDataFound width={250} image="/images/no-data-found.svg" message="No Question found" />}
                </div>
            </UCustomScrollBar>
        </React.Fragment>
    )
}


/**
 * Optional comment under a question's answer, shown when the question was built with "Allow Comment".
 * It never takes part in the mandatory/section validation — a blank comment can never block a submit.
 */
const CommentBox = React.memo((props) => {
    return (
        <UInput className='u_mt-15' label={'Write your comment here'} textarea>
            <textarea
                className="u_textarea u_textarea-two-rows"
                name={`comment-${props?.index}`}
                placeholder=" "
                value={props?.question?.comment || ''}
                autoComplete="off"
                maxLength={500}
                onChange={(e) => props?.handle?.changeComment?.(e.target.value, props?.index)}
            />
        </UInput>
    )
})


const QuestionType = React.memo((props) => {

    return (
        <React.Fragment>
            {/** type 1. Single Line */}
            {props?.question?.type === 1 && <React.Fragment>
                <UInput label="Write your reply here" asterisk={props?.question?.isMandatory}>
                    <input
                        type="text"
                        name={`answer-${props?.index}`}
                        placeholder=" "
                        value={props?.question?.answer}
                        onChange={(e) => props?.handle.change(e?.target?.value, props?.index, `answer`, props?.question?.type)}
                        autoComplete="off" />
                </UInput>
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 2. Multi Line */}
            {props?.question?.type === 2 && <React.Fragment>
                <UInput label="Write your reply here" asterisk={props?.question?.isMandatory} textarea>
                    <textarea
                        className="u_textarea u_textarea-six-rows u_que-textarea"
                        name={`answer-${props?.index}`}
                        value={props?.question?.answer}
                        onChange={(e) => props?.handle.change(e?.target?.value, props?.index, `answer`, props?.question?.type)}
                        placeholder=" " />
                </UInput>
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 3. Yes/No */}
            {props?.question?.type === 3 && <React.Fragment>
                <URadio
                    id={`answer-yes-${props?.index}`}
                    name={`answer-${props?.index}`}
                    label="Yes"
                    htmlFor={`answer-yes-${props?.index}`}
                    checked={props?.question?.answer === true}
                    onChange={(e) => props?.handle.change(e?.target?.checked, props?.index, `answer`, props?.question?.type)}
                    className="u_mb-15"
                />
                <URadio
                    id={`answer-no-${props?.index}`}
                    name={`answer-${props?.index}`}
                    label="No"
                    htmlFor={`answer-no-${props?.index}`}
                    checked={props?.question?.answer === false}
                    onChange={(e) => props?.handle.change(!e?.target?.checked, props?.index, `answer`, props?.question?.type)}
                    className="u_mb-15"
                />
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-no-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 4. Single Choise */}
            {props?.question?.type === 4 && <React.Fragment>
                {props?.question?.options?.length && props?.question?.options?.map((data, i) => {
                    return <URadio
                        key={i}
                        id={`answer-${data?.label}-${props?.index}`}
                        name={`answer-${props?.index}`}
                        label={data?.label}
                        htmlFor={`answer-${data?.label}-${props?.index}`}
                        onChange={(e) => props?.handle.change(data?.label, props?.index, `answer`, props?.question?.type)}
                        checked={props?.question?.answer ? data?.value === props?.question?.answer[0] : false}
                        className="u_mb-15"
                    />
                })}
                {props?.question?.isOtherOption && <React.Fragment>
                    <URadio
                        id={`answer-${props?.index}`}
                        name={`answer-${props?.index}`}
                        label={`Other`}
                        htmlFor={`answer-${props?.index}`}
                        checked={props?.question?.otherOption ? !!props?.question?.otherOption : false}
                        onChange={(e) => props?.handle.change('other-option', props?.index, `answer`, props?.question?.type)}
                        className="u_mb-15"
                    />

                    {props?.question?.otherOption && <UInput label={`Enter other answer`}>
                        <input
                            type="text"
                            name={`answer-other-${props?.index}`}
                            placeholder=" "
                            value={props?.question?.otherOption ? props?.question?.otherOption[0] : ''}
                            onChange={(e) => props?.handle.changeInput(e?.target?.value, props?.index, `answer`, props?.question?.type)}
                            autoComplete="off" />
                    </UInput>}
                </React.Fragment>}
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 5. Multiple Choise */}
            {props?.question?.type === 5 && <React.Fragment>
                {props?.question?.options?.length && props?.question?.options?.map((data, i) => {
                    return <CheckBox
                        key={i}
                        id={`answer-${data?.label}-${props?.index}`}
                        name={`${data?.label}`}
                        label={data?.label}
                        value={data?.label}
                        checked={props?.question?.answer && props?.question?.answer.includes(data?.value) || false}
                        onChange={(e) => props?.handle.change(e.target.value, props?.index, `answer`, props?.question?.type, e)}
                        className="u_block u_mb-15"
                    />
                })}

                {props?.question?.isOtherOption && <React.Fragment>
                    <CheckBox
                        id={`answer-${props?.index}`}
                        name={`answer-${props?.index}`}
                        label={`Other`}
                        htmlFor={`answer-${props?.index}`}
                        checked={props?.question?.otherOption ? !!props?.question?.otherOption : false}
                        onChange={(e) => props?.handle.change('other-option', props?.index, `answer`, props?.question?.type, e)}
                        className="u_mb-15"
                    />

                    {props?.question?.otherOption && <UInput label={`Enter other answer`}>
                        <input
                            type="text"
                            name={`answer-other-${props?.index}`}
                            placeholder=" "
                            value={props?.question?.otherOption ? props?.question?.otherOption[0] : ''}
                            onChange={(e) => props?.handle.changeInput(e?.target?.value, props?.index, `answer`, props?.question?.type)}
                            autoComplete="off" />
                    </UInput>}
                </React.Fragment>}

                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 6. Dropdown */}
            {props?.question?.type === 6 && <React.Fragment>
                <UInput label="Write your reply here" select selectValue={getKeyName(props?.question?.options, props?.question?.answer)}>
                    <Select
                        className="u_input-select-inner u_input-small"
                        placeholder={''}
                        classNamePrefix="u_select"
                        options={props?.question?.options}
                        onChange={(e) => props?.handle.change(e, props?.index, `answer`, props?.question?.type)}
                        // value={getKeyName(props?.question?.options, props?.question?.answer)}
                        value={{ label: props?.question?.answer, value: props?.question?.answer }}
                        name={`answer-${props?.index}`}
                        data-testid="fw.uviewsurvey.input.1.select" />
                </UInput>
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 7. Gender */}
            {props?.question?.type === 7 && <React.Fragment>
                {props?.question?.options?.length && props?.question?.options?.map((data, i) => {
                    return <URadio
                        key={i}
                        id={`answer-${data?.label}-${props?.index}`}
                        name={`answer-${props?.index}`}
                        label={data?.label}
                        htmlFor={`answer-${data?.label}-${props?.index}`}
                        onChange={(e) => props?.handle.change(data?.label, props?.index, `answer`, props?.question?.type)}
                        checked={props?.question?.answer ? data?.value === props?.question?.answer[0] : false}
                        className="u_block u_mb-15"
                    />
                })}
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 8. Email */}
            {props?.question?.type === 8 && <React.Fragment>
                <UInput label="Write your reply here" asterisk={props?.question?.isMandatory}>
                    <input
                        type="text"
                        name={`answer-${props?.index}`}
                        placeholder=" "
                        value={props?.question?.answer}
                        onChange={(e) => props?.handle.change(e?.target?.value, props?.index, `answer`, props?.question?.type)}
                        autoComplete="off" />
                </UInput>
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 9. Number */}
            {props?.question?.type === 9 && <React.Fragment>
                <UInput label="Write your reply here" asterisk={props?.question?.isMandatory}>
                    <input
                        type="number" min={0}
                        name={`answer-${props?.index}`}
                        placeholder=" "
                        value={props?.question?.answer}
                        onChange={(e) => props?.handle.change(e?.target?.value, props?.index, `answer`, props?.question?.type)}
                        onWheelCapture={e => {
                            e.target.blur()
                        }}
                        onKeyDown={e => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()}
                        autoComplete="off" />
                </UInput>
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 10. Date */}
            {props?.question?.type === 10 && <React.Fragment>
                <UInput label="Write your reply here" asterisk={props?.question?.isMandatory} datepicker selectDate={props?.question?.answer || null}>
                    <UDatePicker
                        selected={props?.question?.answer ? new Date(props?.question?.answer) : null}
                        onChange={(e) => props?.handle.change(e, props?.index, `answer`, props?.question?.type)}
                        dateFormat="dd/MM/yyyy"
                        name={`answer-${props?.index}`}
                        placeholderText=" "
                        popperPlacement="bottom-start"
                    />
                </UInput>
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer ? props?.question?.answer : null, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 11. Address */}
            {props?.question?.type === 11 && <React.Fragment>
                <UInput label="Write your reply here" asterisk={props?.question?.isMandatory}>
                    <input
                        type="text"
                        name={`answer-${props?.index}`}
                        placeholder=" "
                        value={props?.question?.answer}
                        onChange={(e) => props?.handle.change(e?.target?.value, props?.index, `answer`, props?.question?.type)}
                        autoComplete="off" />
                </UInput>
                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 12. Slider Range Scale */}
            {props?.question?.type === 12 && <div className="u_que-range-slider">
                <InputRange
                    maxValue={parseInt(props?.question?.end)}
                    minValue={parseInt(props?.question?.start)}
                    value={props?.question?.answer || parseInt(props?.question?.start)}
                    onChange={(e) => props?.handle.change(e, props?.index, `answer`, props?.question?.type)}
                />
                <div className="u_flex u_align-center u_mt-10">
                    <span className="u_que-minmax u_flex-1">{props?.question?.start}</span>
                    <span className="u_que-minmax">{props?.question?.end}</span>
                </div>


                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </div>}
            {/** type 13. Star Rating */}
            {props?.question?.type === 13 && <div className="">
                <div className="u_rating-slider">
                    <ReactStars
                        classNames="u_rating-star"
                        count={props?.question.noOfRange}
                        value={typeof props?.question?.answer === 'string' ? 0 : props?.question?.answer}
                        onChange={(e) => props?.handle.change(e, props?.index, `answer`, props?.question?.type)}
                        size={32}
                        emptyIcon={<Icon.Star size={32} fill={COLOR.u_title} />}
                        fullIcon={<Icon.Star size={32} fill={COLOR.u_blue} />}
                        activeColor={COLOR.u_blue}
                    />
                    <p>{props?.question?.answer || 0}/{props?.question.noOfRange}</p>
                </div>

                {props?.question?.isMandatory &&
                    <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.question?.answer, 'required') && props?.question?.errorMessage}</p>}
            </div>}
            {/** type 14. NPS */}
            {props?.question?.type === 14 && <div className="u_que-text u_que-textarea">
                <p className="u_que-placeholder">{props?.question?.content}</p>
            </div>}
            {/** type 15. Info Box */}
            {props?.question?.type === 15 && <div className="u_que-text u_que-textarea">
                <p className="u_que-placeholder">{props?.question?.content}</p>
            </div>}
            {/** type 17. File Upload */}
            {props?.question?.type === 17 && <React.Fragment>
                {Array?.isArray(props?.fileArray) && props?.fileArray[props?.index]?.url?.length ? <UFileInfo
                    fileInfo={props?.fileArray[props?.index] || null}
                    action={['view', 'download', 'delete']}
                    _S3_BASE_URL={props?._S3_BASE_URL}
                    handleDeleteFile={(e) => props?.handle.clearFile(props?.index, props?.question?._id)}
                /> : <label className="u_que-file-upload">
                    {props?.fileLoader?.[props?.index] ? <Icon.Preloader color1={COLOR.u_blue} color2={COLOR.u_green} size={32} /> :
                        <React.Fragment>
                            <Icon.Upload size={16} fill={COLOR.u_blue} />
                            <span className="u_color-blue">Upload File</span>
                            <input type="file" onChange={(e) => props?.handle.upload(e, props?.index, `answer`, props?.question?.type)} style={{ display: 'none' }} />
                        </React.Fragment>}
                </label>}
                {props?.question?.isMandatory && <p className="u_error">{props?.validator.current.message(`answer-${props?.index}`, props?.fileArray?.[props?.index]?.url, 'required') && props?.question?.errorMessage}</p>}
            </React.Fragment>}
            {/** type 18. Scorecard */}
            {props?.question?.type === 18 && <React.Fragment>
                <p className="u_que-placeholder">{props?.question?.content}</p>
                <ul className="u_evaluation-question">
                    {props?.question?.options?.length && props?.question?.options?.map((data, i) => {
                        return <li key={i} className="u_evaluation-question-inner">
                            <p className="u_small-font u_color-title u_mr-10 u_flex-1">{data?.label}</p>

                            <ul className="u_evaluation-question-options">
                                <li onClick={() => props?.handle.changeScore(1, props?.index, `answer`, props?.question?.type, i)}>
                                    <span className={`u_evaluation-btn ${props?.question?.answer?.[i] === 1 ? 'u_active-red' : ''}`}>
                                        <Icon.DisLike fill={props?.question?.answer?.[i] === 1 ? COLOR.u_red : COLOR.u_icon_bg} size={16} className="" />
                                    </span>
                                </li>
                                <li onClick={() => props?.handle.changeScore(2, props?.index, `answer`, props?.question?.type, i)}>
                                    <span className={`u_evaluation-btn ${props?.question?.answer?.[i] === 2 ? 'u_active-orange' : ''}`}>
                                        <Icon.NotSure fill={props?.question?.answer?.[i] === 2 ? COLOR.u_orange : COLOR.u_icon_bg} size={16} className="" />
                                    </span>
                                </li>
                                <li onClick={() => props?.handle.changeScore(3, props?.index, `answer`, props?.question?.type, i)}>
                                    <span className={`u_evaluation-btn ${props?.question?.answer?.[i] === 3 ? 'u_active-green' : ''}`}>
                                        <Icon.Like fill={props?.question?.answer?.[i] === 3 ? COLOR.u_green : COLOR.u_icon_bg} size={16} className="" />
                                    </span>
                                </li>
                                <li onClick={() => props?.handle.changeScore(4, props?.index, `answer`, props?.question?.type, i)}>
                                    <span className={`u_evaluation-btn ${props?.question?.answer?.[i] === 4 ? 'u_active-green' : ''}`}>
                                        <Icon.DoubleThumbsUp fill={props?.question?.answer?.[i] === 4 ? COLOR.u_green : COLOR.u_icon_bg} size={16} className="" />
                                    </span>
                                </li>
                            </ul>
                        </li>
                    })}
                    {props?.question?.isMandatory && (props?.question?.answer === undefined || props?.question?.answer?.includes(null)) &&
                        <p className="u_error">Please evaluate this candidate</p>}
                </ul>
            </React.Fragment>}
        </React.Fragment>
    );
})
// data?.label?.replace(/[^a-zA-Z0-9]/g, '')
export default ViewForm
